"use client";
import React from "react";
import { InputField } from "@/forms/InputField";
import { useFormContext } from "react-hook-form";
import { TooltipProps } from "@cappelendamm/design-system/react";
import { PHONE_NUMBER_REGEX_ALLOW_SPACE } from "@cappelendamm/e-commerce-services";

type PhoneFieldProps = {
  isDisabled?: boolean;
  tooltip?: TooltipProps;
};

export type PhoneFieldForm = {
  phone: string;
};

export const PhoneField = ({ isDisabled, tooltip }: PhoneFieldProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<PhoneFieldForm>();

  return (
    <InputField
      name="phone"
      label="Telefonnummer"
      register={register}
      error={errors.phone}
      requiredMessage="Du må skrive inn et telefonnummer"
      pattern={{
        value: PHONE_NUMBER_REGEX_ALLOW_SPACE,
        message: "Ugyldig telefonnummer",
      }}
      setValueAs={(value) => (value ? value.replace(/\s/g, "") : "")}
      disabled={isDisabled}
      tooltip={tooltip}
      sensitive
    />
  );
};
